import UserRole from "../../../../common/types/user-role";
import userPermissionsService from "../../../../common/utils/user/permissions/user-permissions.service";
import OrderOptimizerUserPermissionsDefinition, {
  OrderOptimizerUserPermissions,
} from "./order-optimizer-user-permissions";

const getPermissions = (
  userRoles: UserRole[]
): OrderOptimizerUserPermissions => {
  const permissions = userPermissionsService.solvePermissions(
    userRoles,
    OrderOptimizerUserPermissionsDefinition
  );

  return permissions;
};

const orderOptimizerUserPermissionsHelper = {
  getPermissions,
};

export default orderOptimizerUserPermissionsHelper;
